import { getClientUpcomingPayments, GetClientUpcomingPaymentsResponse } from '../api';
import { useLocation } from 'react-router-dom';
import { useQuery, UseQueryResult } from '@tanstack/react-query';

interface UseClientUpcomingPaymentsRequest {
  orgId: string | null | undefined;
}

export const useClientUpcomingPayments = (
  payload: UseClientUpcomingPaymentsRequest
): UseQueryResult<GetClientUpcomingPaymentsResponse, Error> => {
  const {
    orgId
  } = payload;

  const location = useLocation();
  const clientOrgId = orgId ?? '';

  return useQuery({
    enabled: Boolean(orgId),
    queryFn: () => getClientUpcomingPayments({ orgId: clientOrgId }),
    queryKey: ['getClientUpcomingPayments', location.pathname, orgId],
    retry: 1
  });
};